import BasicRepository from "./basicRepository";
import Client from "../client";
import {TagSetResource} from "../resources/tagSetResource";

class TagSetRepository extends BasicRepository<TagSetResource, TagSetResource> {
    constructor(client: Client) {
        super("TagSets", client);
    }
    sort(ids: string[]) {
        return this.client.put(this.client.getRootDocument().Links["TagSetSortOrder"], ids);
    }
}

export default TagSetRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/tagSetRepository.ts